import { useState, useEffect, useRef, useMemo } from 'react';

import Co2Api from '@src/api/Co2Api';
import { useIState } from "@src/hooks/react"
import { useAppContext } from "@src/contexts/App/AppContext";

import InfiniteProgress from './UI/InfiniteProgress';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import FieldError from "./UI/FieldError";

import isURL from 'validator/lib/isURL';

import { Trans, t } from '@lingui/macro';

const SearchForm = () => {
    const [appState, AppActions] = useAppContext();

    let [isSending, setSending] = useIState(false);
    let [error, setError] = useIState(null);

    const schema = useMemo(() => {
        return yup.object({
            url: yup.string().required(t`Campo richiesto`).test("valid-url", t`Url non valida`, (value) => value && isURL(value)),
            email: yup.string().required(t`Campo richiesto`).email(t`Email non valida`),
        }).required();
    }, []);

    const { register, handleSubmit, reset, watch, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const abortLoad = useRef(null);

    useEffect(() => {
        return () => {
            if (abortLoad.current) {
                abortLoad.current.abort()
            }
        }
    }, []);

    const onSubmit = (data) => {
        console.log(data);

        AppActions.resetAll();

        setError(pre => null);
        setSending(pre => true);

        if (abortLoad.current) {
            abortLoad.current.abort()
        }
        abortLoad.current = new AbortController();

        Co2Api.post("statistics/", {
            lang: co2_form_info.lang,
            ...data

        }).then(function (response) {
            if (response?.data) {
                AppActions.setStatistics(response.data);
                AppActions.setLead({ email: data.email });
                reset({ email: "", url: "" });

                try {
                    
                    gtag('event', "lending_contact", {
                        'event_category': "partners",
                    });
                    
                    fbq('track', 'Contact');

                    console.log("Trigger:lending_contact");
                } catch (error) {
                    console.log(error);
                }

            } else {
                setError(pre => "An error accurred");
            }

        }).catch(function (error) {
            let errorMsg = t`Servizio al momento non disponibile`;
            setError(pre => error?.response?.data?.message ?? errorMsg);
        }).then(function () {
            setSending((pre) => false);
        })

    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="mb-3">
                    <input type="text" className="form-control rounded-5" placeholder={t`L'indirizzo della tua pagina web*`} disabled={isSending} {...register("url")} />
                    <FieldError message={errors.url?.message} />
                </div>

                <div className="mb-3">
                    <input type="email" className="form-control rounded-5" placeholder={t`Email*`} {...register("email")} disabled={isSending} />
                    <FieldError message={errors.email?.message} />
                </div>

                <div className="mb-3">
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="1" required disabled={isSending} style={{marginRight:5}} />
                        <label className="form-check-label">                           
                            <Trans>
                                Ho letto e accetto <a href="https://www.iubenda.com/privacy-policy/68120255" target='_blank'>l'informativa privacy</a>
                            </Trans>
                        </label>
                    </div>
                </div>

                <div className="mb-3">
                    <button type="submit" className="btn btn-primary px-5 rounded-5 w-100" disabled={isSending}>
                        <Trans>Invia</Trans>
                    </button>
                </div>

                {isSending ? <InfiniteProgress text={t`Analisi in corso. Attendi qualche secondo`} /> : null}

                {error ? (<div className="invalid-feedback d-block">{error}</div>) : null}
            </form>
        </>
    );
}

export default SearchForm;
